export const WIMS_PULSE_SERVICE_HOST = 'https://wims-pulse-234667209142.us-central1.run.app';

export const WIMS_PULSE_PATHS = {
  status: `${WIMS_PULSE_SERVICE_HOST}/status`,
};
